import { get } from "../../utils/objectHelpers";
import { buildImageUrlByZoomId } from "../../utils/imageUrlBuilder";

$ {
    const { imageId, imageSize, useUrl, URL, format = "jpg", originalSize = {}, title = "", ...attributes } = input;
    const usedImageSize = imageSize
        ? imageSize
        : originalSize.width > originalSize.height
            ? originalSize.width
            : originalSize.height;
    const useZoomId = !useUrl && !!imageId && !!usedImageSize;
    const imageUrl = useZoomId ? buildImageUrlByZoomId(imageId, usedImageSize, format) : URL;
    const webpImageUrl = useZoomId ? buildImageUrlByZoomId(imageId, usedImageSize, "webp") : null;
    const imageAttributes = {
        ...attributes,
        src: imageUrl,
        title,
    };
    if (!input.alt && input.title) {
        imageAttributes.alt = input.title;
    }
}

<if(imageAttributes.src)>
  <picture class="str-image">
    <if(webpImageUrl)>
      <source srcset=webpImageUrl type="image/webp">
    </if>
    <img ...imageAttributes>
  </picture>
</if>
